(function () {
  const popup = document.querySelector('.homepage-popup');
  if (!popup) return;

  const dialog = popup.querySelector('.homepage-popup__dialog');
  const closeTriggers = popup.querySelectorAll('[data-popup-close]');
  const delay = (parseFloat(popup.dataset.delay) || 0) * 1000;
  const showOnce = popup.dataset.showOnce === 'true';
  const themeEditor = Boolean(window.Shopify && window.Shopify.designMode);
  const storageKey = 'homepage-popup-dismissed';

  let openTimer = null;
  let lastFocusedElement = null;

  function isDismissed() {
    if (!showOnce || themeEditor) return false;

    try {
      if (window.localStorage.getItem(storageKey)) return true;
    } catch (error) {}

    return typeof getCookie === 'function' && Boolean(getCookie(storageKey));
  }

  function rememberDismissal() {
    if (!showOnce || themeEditor) return;

    try {
      window.localStorage.setItem(storageKey, '1');
      return;
    } catch (error) {}

    if (typeof setCookie === 'function') setCookie(storageKey, true, 400);
  }

  function getFocusable() {
    return Array.from(
      dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
    );
  }

  function trapFocus(event) {
    const focusable = getFocusable();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function onKeydown(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      closePopup();
    } else if (event.key === 'Tab') {
      trapFocus(event);
    }
  }

  function openPopup() {
    lastFocusedElement = document.activeElement;

    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('scroll-lock');
    document.addEventListener('keydown', onKeydown);

    const closeButton = popup.querySelector('.homepage-popup__close');
    if (closeButton) closeButton.focus({ preventScroll: true });
  }

  function closePopup() {
    clearTimeout(openTimer);
    rememberDismissal();

    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('scroll-lock');
    document.removeEventListener('keydown', onKeydown);

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus({ preventScroll: true });
    }
  }

  closeTriggers.forEach(trigger => {
    trigger.addEventListener('click', closePopup);
  });

  if (!isDismissed()) {
    openTimer = setTimeout(openPopup, delay);
  }
})();
